import api from "../middlware/api";
import { camelToSnake } from "../utils/CamelToSnake";

const BASE = "/api/v1/ot-templates";

export interface OtTemplate {
  id: number;
  name: string;
  operationDetails?: string;
  findings?: string;
  complications?: string;
  implants?: string;
  notes?: string;
}

export const getOtTemplates = () => api.get(BASE);

export const createOtTemplate = (data: Omit<OtTemplate, "id">) =>
  api.post(BASE, camelToSnake(data));

export const updateOtTemplate = (id: number, data: Partial<Omit<OtTemplate, "id">>) =>
  api.put(`${BASE}/${id}`, camelToSnake(data));

export const deleteOtTemplate = (id: number) => api.delete(`${BASE}/${id}`);
